// Types
import { ParsedUrlQuery } from 'querystring';

// Memorabilia and Products are a single shop category everywhere now, so any
// productType query param (whichever legacy value it carries) - or browsing
// the dedicated /products page - means "scope this search to shop items."
export const getIsMemorabiliaSrpPage = (
  query: ParsedUrlQuery,
  pathname: string
): boolean => {
  return pathname === '/products' || Boolean(query?.productType);
};
